import React from 'react';
import { 
  FaFacebookF, 
  FaInstagram, 
  FaTwitter, 
  FaPinterest,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaShieldAlt,
  FaFileAlt,
  FaSitemap,
  FaCouch,
  FaBed,
  FaUtensils,
  FaChair,
  FaLightbulb
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-12 pb-4">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="flex flex-col">
            <div className="-mt-4 mb-3">
              <img 
                src="/logo.png" 
                alt="Home Fashion Logo"
                className="h-32 w-auto object-contain"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/250x100?text=HOME+FASHION+VARANASI';
                }}
              />
            </div>
            <p className="text-gray-400 mb-3 text-sm leading-relaxed max-w-xs -mt-1">
              Your one-stop destination for premium home furnishings and decor in Varanasi. Making houses beautiful since 2010.
            </p>
            <div className="flex space-x-3 mt-2">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-all duration-300 transform hover:scale-110">
                <FaFacebookF size={14} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-all duration-300 transform hover:scale-110">
                <FaInstagram size={14} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-400 transition-all duration-300 transform hover:scale-110">
                <FaTwitter size={14} />
              </a>
              <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-all duration-300 transform hover:scale-110">
                <FaPinterest size={14} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-5 text-white uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-pink-500 transition-colors duration-300 text-sm flex items-center gap-2">
                  <span className="w-1 h-1 bg-pink-500 rounded-full"></span>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-pink-500 transition-colors duration-300 text-sm flex items-center gap-2">
                  <span className="w-1 h-1 bg-pink-500 rounded-full"></span>
                  Products
                </Link>
              </li>
              <li>
                <Link to="/collections" className="text-gray-400 hover:text-pink-500 transition-colors duration-300 text-sm flex items-center gap-2">
                  <span className="w-1 h-1 bg-pink-500 rounded-full"></span>
                  Collections
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-pink-500 transition-colors duration-300 text-sm flex items-center gap-2">
                  <span className="w-1 h-1 bg-pink-500 rounded-full"></span>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories - with ALL LINKS ADDED */}
          <div>
            <h3 className="text-lg font-semibold mb-5 text-white uppercase tracking-wider">Categories</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/living-room" className="text-gray-400 hover:text-pink-500 transition-colors duration-300 text-sm flex items-center gap-3 group">
                  <FaCouch className="text-pink-500 text-base group-hover:scale-110 transition-transform" />
                  Living Room
                </Link>
              </li>
              <li>
                <Link to="/bedroom" className="text-gray-400 hover:text-pink-500 transition-colors duration-300 text-sm flex items-center gap-3 group">
                  <FaBed className="text-pink-500 text-base group-hover:scale-110 transition-transform" />
                  Bedroom
                </Link>
              </li>
              <li>
                <Link to="/dining" className="text-gray-400 hover:text-pink-500 transition-colors duration-300 text-sm flex items-center gap-3 group">
                  <FaUtensils className="text-pink-500 text-base group-hover:scale-110 transition-transform" />
                  Dining
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-5 text-white uppercase tracking-wider">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <FaMapMarkerAlt className="text-pink-500 mt-1 text-base flex-shrink-0" />
                <span className="text-gray-400 text-sm">Rathyatra-Mahmmoorganj Road,<br />Varanasi - 221010, India</span>
              </li>
              <li className="flex items-center gap-3">
                <FaPhone className="text-pink-500 text-base flex-shrink-0" />
                <a href="tel:+918573035759" className="text-gray-400 text-sm hover:text-pink-500 transition-colors duration-300">+91 8573035759</a>
              </li>
              <li className="flex items-center gap-3">
                <FaEnvelope className="text-pink-500 text-base flex-shrink-0" />
                <a href="mailto:info@homefashion.com" className="text-gray-400 text-sm hover:text-pink-500 transition-colors duration-300">info@homefashion.com</a>
              </li>
              <li className="flex items-center gap-3">
                <FaClock className="text-pink-500 text-base flex-shrink-0" />
                <span className="text-gray-400 text-sm">Mon - Sat: 10am - 8pm</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Copyright */}
            <p className="text-gray-500 text-xs order-2 md:order-1">
              © {new Date().getFullYear()} Home Fashion, Varanasi. All rights reserved.
            </p>
            
            {/* Legal Links */}
            <div className="flex flex-wrap justify-center gap-4 md:gap-6 order-1 md:order-2">
              <Link 
                to="/privacy-policy" 
                className="text-gray-400 hover:text-pink-500 transition-colors duration-300 text-xs flex items-center gap-1"
              >
                <FaShieldAlt size={12} />
                Privacy Policy
              </Link>
              <Link 
                to="/terms" 
                className="text-gray-400 hover:text-pink-500 transition-colors duration-300 text-xs flex items-center gap-1"
              >
                <FaFileAlt size={12} />
                Terms & Conditions
              </Link>
              <Link 
                to="/sitemap" 
                className="text-gray-400 hover:text-pink-500 transition-colors duration-300 text-xs flex items-center gap-1"
              >
                <FaSitemap size={12} />
                Sitemap
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;